import React from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import GatsbyImage from "../../../Image";
import Markdown from "../../../Markdown";
import Button from "../../../NewForms/Button";
import NewHeadline from "../../../NewHeadline";

const Text = styled(Markdown)`
    font-size: 1rem;
    ${({ theme }) => css`
        color: ${theme.colors.blue.toString()};
    `}
    ul {
        margin: 0;
    }
`;

const ActionRow = styled.div`
    display: flex;
    justify-content: center;
`;

const Card = ({ item }) => {
    return (
        <div>
            {item.src && <GatsbyImage src={item.src} />}
            <NewHeadline is={2}>{item.name}</NewHeadline>
            <Text>{item.text}</Text>
            {item.linkOptional && item.linkOptional.href && (
                <ActionRow>
                    <Button to={item.linkOptional.href}>
                        {item.linkOptional.text}
                    </Button>
                </ActionRow>
            )}
        </div>
    );
};

export default Card;
